import {
    BulletinListExportExcelResponse
} from '../../../../../infrastructure/remote/sacmi/dto/response/BulletinListExportExcelResponse';
import {
    BulletinListExportPdfResponse
} from '../../../../../infrastructure/remote/sacmi/dto/response/BulletinListExportPdfResponse';
import ExportBulletinListExcelDataMapper
    from '../api/mapper/request/ExportBulletinListExcelDataMapper';
import ExportBulletinListPdfDataMapper
    from '../api/mapper/request/ExportBulletinListPdfDataMapper';
import {ApiClientResponse} from '../../../../../infrastructure/remote/sacmi/dto/ApiClient';
import {BulletinRepository} from '../../../domain/repository/BulletinRepository';
import {BulletinListFilters} from '../../../view/useBulletinListFilters';

export class ApiBulletinRepository implements BulletinRepository {
    constructor(private apiClient: ApiClientResponse) {}

    public async exportPdf(bulletinIds: string[], filters: BulletinListFilters): Promise<BulletinListExportPdfResponse> {
        try {
            return await this.apiClient.bulletinListExportPdf(ExportBulletinListPdfDataMapper.fromDomain(bulletinIds, filters));
        } catch (error) {
            return Promise.reject(error);
        }
    }

    public async exportExcel(bulletinIds: string[], filters: BulletinListFilters): Promise<BulletinListExportExcelResponse> {
        try {
            return await this.apiClient.bulletinListExportExcel(ExportBulletinListExcelDataMapper.fromDomain(bulletinIds, filters));
        } catch (error) {
            return Promise.reject(error);
        }
    }
}
